const goToApplets = () =>
    import('@/module/index/pages/userCenter/goToApplets.vue')

export default {
  path: '/goToApplets',
  component: goToApplets,
  meta: {
    title: '',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: false
  }
}



// WEBPACK FOOTER //
// ./src/publicResource/router/applets.js